module.exports = __webpack_public_path__ + "images/gavdos/news2.jpg";